import { AUTH_TOKEN_KEY } from './constants/localStorageKey'

const OLD_AUTH_TOKEN = 'old_auth_token'

const getAuthToken = () => localStorage.getItem(AUTH_TOKEN_KEY)

const setAuthToken = (token: string) => localStorage.setItem(AUTH_TOKEN_KEY, token)

const clearAuthToken = () => localStorage.removeItem(AUTH_TOKEN_KEY)

// The token's own expiry ("Bearer <jwt>", `exp` in seconds). An unreadable
// token is left to the APIs to judge.
const isAuthTokenExpired = () => {
  try {
    const payload = getAuthToken()
      ?.replace(/^Bearer /, '')
      .split('.')[1]
    if (!payload) return false
    const { exp } = JSON.parse(atob(payload.replace(/-/g, '+').replace(/_/g, '/')))
    return typeof exp === 'number' && exp * 1000 <= Date.now()
  } catch {
    return false
  }
}

const setOldAuthToken = (token: string) => localStorage.setItem(OLD_AUTH_TOKEN, token)

const getOldAuthToken = () => localStorage.getItem(OLD_AUTH_TOKEN)

const clearStorage = () => localStorage.clear()

const logout = () => {
  const authToken = getAuthToken()
  setOldAuthToken(authToken || '')
  clearStorage()
}

const storageUtils = {
  getAuthToken,
  setAuthToken,
  clearAuthToken,
  isAuthTokenExpired,
  clearStorage,
  logout,
  getOldAuthToken,
}

export default storageUtils
